import { render } from "./EventCourse.vue?vue&type=template&id=71d3cac7&scoped=true&ts=true"
import script from "./EventCourse.vue?vue&type=script&lang=ts"
export * from "./EventCourse.vue?vue&type=script&lang=ts"

import "./EventCourse.vue?vue&type=style&index=0&id=71d3cac7&lang=css"
import "./EventCourse.vue?vue&type=style&index=1&id=71d3cac7&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71d3cac7"]])

export default __exports__